import { component } from 'picoapp'
import { qs, on } from 'martha'
import dcx from 'dcx'

export default component((node) => {
  const input = qs('input[type="checkbox"]', node)
  const text = qs('.js-text', node)
  const textCx = dcx(text)

  on(input, 'change', () => {
    textCx({
      'font-medium text-royal-blue': input.checked,
    })
  })
})
